import * as ko from 'knockout'
import {AttachmentDto} from "../../../api/generated";
import {autobind} from "knockout-decorators";
import {attachmentDocuments} from "./attachmentUtils";
import {config} from "../../../utils/clientConfigWrapper";

interface ViewModelParams {
    attachmentList: KnockoutComputed<AttachmentDto[]>;
    headlineVisible: boolean;
    deleteLinkVisible: boolean
}

class ViewModel {

    /**
     * The complete attachment list.
     */
    public attachmentList: KnockoutComputed<AttachmentDto[]>;

    /**
     * The documents from the attachment list.
     */
    public documents: KnockoutComputed<AttachmentDto[]>;

    /**
     * Show the headline
     */
    public headlineVisible: KnockoutObservable<boolean>;

    /**
     * Show the delete link
     */
    public deleteLinkVisible: KnockoutObservable<boolean>;

    /**
     * Constructor.
     *
     * @param params
     */
    constructor(private params: ViewModelParams) {
        const isEdit = params.deleteLinkVisible === true ? true : false;
        this.attachmentList = params.attachmentList;
        this.documents = attachmentDocuments(this.attachmentList, isEdit);
        this.headlineVisible = ko.observable(params.headlineVisible === true ? true : false);
        this.deleteLinkVisible = ko.observable(isEdit);
    }

    /**
     * Get the document path.
     *
     * @param attachment
     */
    public documentPath(attachment: AttachmentDto): string {
        return `${config.attachmentEndpoint}${attachment.filename}`;
    }

    /**
     * Get the document name without the path.
     *
     * @param attachment
     */
    public documentName(attachment: AttachmentDto): string {
        return attachment.filename.substr(attachment.filename.lastIndexOf('/') + 1);
    }

    /**
     * Deletes an attachment
     * @param attachment
     */
    @autobind
    public deleteAttachment(attachment: AttachmentDto) {
        this.attachmentList().splice(this.attachmentList().indexOf(attachment), 1);
    }

}

const component: KnockoutComponentTypes.Config = {
    viewModel: (params: ViewModelParams) => new ViewModel(params),
    template: <string>require('./documents.html')
};

export default component;

if (!ko.components.isRegistered('documents')) {
    ko.components.register('documents', component)
}